'use client';

import classNames from 'classnames';

import { inter500, inter600 } from '@/config/fonts';

import LayoutColumnSvg from '@/assets/svgs/contact-lists/layout-column.svg';
import SparklesTwoSvg from '@/assets/svgs/contact-lists/sparkles-two.svg';
import SelectColumnForField from '@/containers/ContactLists/FieldMapping/SelectColumnForField';
import { ColumnData } from '@/containers/ContactLists/types';

interface P2PUploadStep3SuggestFirstNameProps {
  className?: string;
  suggestedFirstNameColumn?: ColumnData; // Suggested column for first names, could be null or an object
  selectedFirstNameColumn?: ColumnData; // Currently selected column for first names, could be null or an object
  columnsOtherThanSuggestedFirstNameColumn?: ColumnData[]; // Array of columns excluding the suggested first name column, could be null or an array of objects
  setSelectedFirstNameColumn: (column: ColumnData) => void; // Function to set the selected first name column
}

const P2PUploadStep3SuggestFirstName = ({
  className,
  suggestedFirstNameColumn,
  selectedFirstNameColumn,
  columnsOtherThanSuggestedFirstNameColumn,
  setSelectedFirstNameColumn,
}: P2PUploadStep3SuggestFirstNameProps) => {
  return (
    <div className={classNames('', className)}>
      <div className="pb-4">
        <div className={classNames(inter600.className, 'text-2xl')}>
          Select the Column Which Contains{' '}
          <span className="text-primary">First Name</span> of Your Contacts
        </div>
        <div className={classNames('pt-2 text-sm text-gray-600 dark:text-gray-400')}>
          First Name data is valuable to the success of your P2P Jobs. Please select which
          column has the First Name data.
        </div>
      </div>

      <>
        <div className="flex flex-col gap-6">
          {!!suggestedFirstNameColumn && (
            <div className="flex flex-col gap-3">
              <div className="flex h-9 items-center gap-3">
                <SparklesTwoSvg />
                <span
                  className={classNames(inter500.className, 'text-gray-default text-sm')}>
                  Suggested
                </span>
              </div>
              <SelectColumnForField
                columnData={suggestedFirstNameColumn}
                onSelect={setSelectedFirstNameColumn}
                selected={
                  suggestedFirstNameColumn.columnNumber ===
                  selectedFirstNameColumn?.columnNumber
                }
              />
            </div>
          )}
          <div className="flex flex-col gap-3">
            {suggestedFirstNameColumn &&
              !!columnsOtherThanSuggestedFirstNameColumn?.length && (
                <div className="flex h-9 items-center gap-3">
                  <LayoutColumnSvg />
                  <span
                    className={classNames(
                      inter500.className,
                      'text-gray-default text-sm'
                    )}>
                    Other columns
                  </span>
                </div>
              )}
            <div className="flex flex-wrap gap-4">
              {columnsOtherThanSuggestedFirstNameColumn?.map((data, idx) => {
                return (
                  <SelectColumnForField
                    key={idx}
                    columnData={data}
                    onSelect={setSelectedFirstNameColumn}
                    selected={data.columnNumber === selectedFirstNameColumn?.columnNumber}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default P2PUploadStep3SuggestFirstName;
